import type { AllRouteEndpoints } from "../routeTypes";
export const engagementSegmentPreviewAppGroupIdCacheKeys: AllRouteEndpoints[] = [];

export const engagementSegmentPreviewResult = "/engagement/segment_preview/:app_group_id";
